/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum SignatureType {
  PERSONAL_SIGN = 'personal_sign',
  ETH_SIGN_TYPED_DATA_V4 = 'eth_signTypedData_v4',
}

export function SignatureTypeFromJSON(json: any): SignatureType {
  return SignatureTypeFromJSONTyped(json, false)
}

export function SignatureTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureType {
  return json as SignatureType
}

export function SignatureTypeToJSON(value?: SignatureType | null): any {
  return value as any
}
